export default __webpack_public_path__ + "static/034-1d03af7d5a4bca5f9d403947ee78a4de.png";